import ChungTuPhaiThuKhacChungTuBuTruCongNoDocumentEntry from '@/features/ban-hang/dieu-chinh-can-tru-cong-no/chung-tu-phai-thu-khac-chung-tu-bu-tru-cong-no/DocumentEntry';
import ButToanDieuChinhGiamCongNoMuaHangDocumentEntry from '@/features/mua-hang/dieu-chinh-can-tru-cong-no/but-toan-dieu-chinh-giam-cong-no/DocumentEntry';
import HoaDonDichVuTraLaiNhaCungCapDocumentEntry from '@/features/mua-hang/hoa-don-dieu-chinh-tra-lai/hoa-don-dich-vu-tra-lai-nha-cung-cap/DocumentEntry';
import PhieuNhapDieuChinhGiaHangMuaDocumentEntry from '@/features/mua-hang/hoa-don-dieu-chinh-tra-lai/phieu-nhap-dieu-chinh-gia-hang-mua/DocumentEntry';
import ChungTuPhaiTraKhacChungTuBuTruCongNoDocumentEntry from '@/features/mua-hang/dieu-chinh-can-tru-cong-no/chung-tu-bu-tru-cong-no/DocumentEntry';
import ButToanDieuChinhGiamCongNoDocumentEntry from '@/features/ban-hang/dieu-chinh-can-tru-cong-no/but-toan-dieu-chinh-giam-cong-no/DocumentEntry';
import HoaDonDichVuTraLaiGiamGiaDocumentEntry from '@/features/ban-hang/hoa-don-dieu-chinh-tra-lai/hoa-don-dich-vu-tra-lai-giam-gia/DocumentEntry';
import PhieuXuatTraLaiNhaCungCapDocumentEntry from '@/features/mua-hang/hoa-don-dieu-chinh-tra-lai/phieu-xuat-tra-lai-nha-cung-cap/DocumentEntry';
import HoaDonDieuChinhGiaHangBanDocumentEntry from '@/features/ban-hang/hoa-don-dieu-chinh-tra-lai/hoa-don-dieu-chinh-gia-hang-ban/DocumentEntry';
import PhieuNhapHangBanTraLaiDocumentEntry from '@/features/ban-hang/hoa-don-dieu-chinh-tra-lai/phieu-nhap-hang-ban-tra-lai/DocumentEntry';
import PhieuNhapChiPhiMuaHangDocumentEntry from '@/features/mua-hang/hoa-don-mua-vao/phieu-nhap-chi-phi-mua-hang/DocumentEntry';
import HoaDonMuaHangTrongNuocDocumentEntry from '@/features/mua-hang/hoa-don-mua-vao/hoa-don-mua-hang-trong-nuoc/DocumentEntry';
import PhieuThanhToanTamUngDocumentEntry from '@/features/mua-hang/thanh-toan-tam-ung/phieu-thanh-toan-tam-ung/DocumentEntry';
import PhieuKeToanTheoNghiepVuDocumentEntry from '@/features/tong-hop/hach-toan/phieu-ke-toan-theo-nghiep-vu/DocumentEntry';
import HoaDonMuaDichVuDocumentEntry from '@/features/mua-hang/hoa-don-mua-vao/hoa-don-mua-dich-vu/DocumentEntry';
import HoaDonDichVuDocumentEntry from '@/features/ban-hang/hoa-don-ban-ra/hoa-don-ban-dich-vu/DocumentEntry';
import HoaDonBanHangDocumentEntry from '@/features/ban-hang/hoa-don-ban-ra/hoa-don-ban-hang/DocumentEntry';
import PhieuXuatDieuChuyenDocumentEntry from '@/features/ton-kho/phieu-xuat-dieu-chuyen/DocumentEntry';
import PhieuNhapDieuChuyenDocumentEntry from '@/features/ton-kho/phieu-nhap-dieu-chuyen/DocumentEntry';
import ButToanHuyDocumentEntry from '@/features/tong-hop/but-toan-cuoi-ky/but-toan-huy/DocumentEntry';
import PhieuKeToanDocumentEntry from '@/features/tong-hop/hach-toan/phieu-ke-toan/DocumentEntry';
import GiayBaoNoDocumentEntry from '@/features/tien-gui/hach-toan/giay-bao-no/DocumentEntry';
import GiayBaoCoDocumentEntry from '@/features/tien-gui/hach-toan/giay-bao-co/DocumentEntry';
import PhieuThuDocumentEntry from '@/features/tien-mat/hach-toan/phieu-thu/DocumentEntry';
import PhieuChiDocumentEntry from '@/features/tien-mat/hach-toan/phieu-chi/DocumentEntry';
import PhieuXuatKhoDocumentEntry from '@/features/ton-kho/phieu-xuat-kho/DocumentEntry';
import PhieuNhapKhoDocumentEntry from '@/features/ton-kho/phieu-nhap-kho/DocumentEntry';
import type { LedgerDocumentEntryState } from '../utils/document-entry';

interface LedgerDocumentEntryProps {
  document: LedgerDocumentEntryState;
  onClose: () => void;
  onMutated?: () => void | Promise<void>;
}

export default function DocumentEntry({ document, onClose, onMutated }: LedgerDocumentEntryProps) {
  const entryProps = {
    document_uuid: document.documentUuid,
    document_type: document.documentType,
    formMode: 'view' as const,
    onClose,
    onMutated
  };

  switch (document.entryType) {
    case 'BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO':
      return <ButToanDieuChinhGiamCongNoDocumentEntry {...entryProps} />;
    case 'BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO_MH':
      return <ButToanDieuChinhGiamCongNoMuaHangDocumentEntry {...entryProps} />;
    case 'BUT_TOAN_HUY':
      return <ButToanHuyDocumentEntry {...entryProps} />;
    case 'CHUNG_TU_PHAI_THU_KHAC_CHUNG_TU_BU_TRU_CONG_NO':
      return <ChungTuPhaiThuKhacChungTuBuTruCongNoDocumentEntry {...entryProps} />;
    case 'CHUNG_TU_PHAI_TRA_KHAC':
      return <ChungTuPhaiTraKhacChungTuBuTruCongNoDocumentEntry {...entryProps} />;
    case 'GIAY_BAO_CO':
      return <GiayBaoCoDocumentEntry {...entryProps} />;
    case 'GIAY_BAO_NO':
      return <GiayBaoNoDocumentEntry {...entryProps} />;
    case 'HOA_DON_BAN_DICH_VU':
      return <HoaDonDichVuDocumentEntry {...entryProps} />;
    case 'HOA_DON_BAN_HANG':
      return <HoaDonBanHangDocumentEntry {...entryProps} />;
    case 'HOA_DON_DICH_VU_TRA_LAI_GIAM_GIA':
      return <HoaDonDichVuTraLaiGiamGiaDocumentEntry {...entryProps} />;
    case 'HOA_DON_DICH_VU_TRA_LAI_NHA_CUNG_CAP':
      return <HoaDonDichVuTraLaiNhaCungCapDocumentEntry {...entryProps} />;
    case 'HOA_DON_DIEU_CHINH_GIA_HANG_BAN':
      return <HoaDonDieuChinhGiaHangBanDocumentEntry {...entryProps} />;
    case 'HOA_DON_MUA_DICH_VU':
      return <HoaDonMuaDichVuDocumentEntry {...entryProps} />;
    case 'HOA_DON_MUA_HANG_TRONG_NUOC':
      return <HoaDonMuaHangTrongNuocDocumentEntry {...entryProps} />;
    case 'PHIEU_CHI':
      return <PhieuChiDocumentEntry {...entryProps} />;
    case 'PHIEU_KE_TOAN':
      return <PhieuKeToanDocumentEntry {...entryProps} />;
    case 'PHIEU_KE_TOAN_THEO_NGHIEP_VU':
      return <PhieuKeToanTheoNghiepVuDocumentEntry {...entryProps} />;
    case 'PHIEU_NHAP_CHI_PHI_MUA_HANG':
      return <PhieuNhapChiPhiMuaHangDocumentEntry {...entryProps} />;
    case 'PHIEU_NHAP_DIEU_CHINH_GIA_HANG_MUA':
      return <PhieuNhapDieuChinhGiaHangMuaDocumentEntry {...entryProps} />;
    case 'PHIEU_NHAP_DIEU_CHUYEN':
      return <PhieuNhapDieuChuyenDocumentEntry {...entryProps} />;
    case 'PHIEU_NHAP_HANG_BAN_TRA_LAI':
      return <PhieuNhapHangBanTraLaiDocumentEntry {...entryProps} />;
    case 'PHIEU_NHAP_KHO':
      return <PhieuNhapKhoDocumentEntry {...entryProps} />;
    case 'PHIEU_THANH_TOAN_TAM_UNG':
      return <PhieuThanhToanTamUngDocumentEntry {...entryProps} />;
    case 'PHIEU_THU':
      return <PhieuThuDocumentEntry {...entryProps} />;
    case 'PHIEU_XUAT_DIEU_CHUYEN':
      return <PhieuXuatDieuChuyenDocumentEntry {...entryProps} />;
    case 'PHIEU_XUAT_KHO':
      return <PhieuXuatKhoDocumentEntry {...entryProps} />;
    case 'PHIEU_XUAT_TRA_LAI_NHA_CUNG_CAP':
      return <PhieuXuatTraLaiNhaCungCapDocumentEntry {...entryProps} />;
    default:
      return null;
  }
}
